/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Coverage outcome of the matcher.
 * - `full` — the user's FNC covers a standard award stay outright.
 * - `top_up` — the FNC plus a points top-up covers the stay (Phase 4b chains only).
 * - `none` — the matcher ran but the cap fell short.
 * 
 * @export
 */
export const FreeNightMatchCoverage = {
    Full: 'full',
    TopUp: 'top_up',
    None: 'none'
} as const;
export type FreeNightMatchCoverage = typeof FreeNightMatchCoverage[keyof typeof FreeNightMatchCoverage];


export function instanceOfFreeNightMatchCoverage(value: any): boolean {
    for (const key in FreeNightMatchCoverage) {
        if (Object.prototype.hasOwnProperty.call(FreeNightMatchCoverage, key)) {
            if (FreeNightMatchCoverage[key as keyof typeof FreeNightMatchCoverage] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreeNightMatchCoverageFromJSON(json: any): FreeNightMatchCoverage {
    return FreeNightMatchCoverageFromJSONTyped(json, false);
}

export function FreeNightMatchCoverageFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightMatchCoverage {
    return json as FreeNightMatchCoverage;
}

export function FreeNightMatchCoverageToJSON(value?: FreeNightMatchCoverage | null): any {
    return value as any;
}

export function FreeNightMatchCoverageToJSONTyped(value: any, ignoreDiscriminator: boolean): FreeNightMatchCoverage {
    return value as FreeNightMatchCoverage;
}

